import { Box, Stack } from '@mui/material';
import React from 'react';

import { LayoutBackgroundStyles } from '@/layouts/private/Layout.styles.ts';

const brandingItems = [
  { column: 0, opacity: 0.12, rotate: -18, side: 'left', size: 56, top: '10%' },
  { column: 1, opacity: 0.08, rotate: 14, side: 'left', size: 42, top: '16%' },
  { column: 0, opacity: 0.1, rotate: -12, side: 'left', size: 44, top: '24%' },
  { column: 1, opacity: 0.15, rotate: -26, side: 'left', size: 64, top: '34%' },
  { column: 0, opacity: 0.16, rotate: 10, side: 'left', size: 66, top: '42%' },
  { column: 1, opacity: 0.09, rotate: 18, side: 'left', size: 46, top: '52%' },
  { column: 0, opacity: 0.13, rotate: 24, side: 'left', size: 52, top: '62%' },
  { column: 1, opacity: 0.14, rotate: -10, side: 'left', size: 58, top: '72%' },
  { column: 0, opacity: 0.1, rotate: 14, side: 'left', size: 40, top: '80%' },
  { column: 1, opacity: 0.08, rotate: -22, side: 'left', size: 44, top: '88%' },
  { column: 0, opacity: 0.18, rotate: 16, side: 'right', size: 74, top: '12%' },
  { column: 1, opacity: 0.09, rotate: -18, side: 'right', size: 46, top: '20%' },
  { column: 0, opacity: 0.14, rotate: 22, side: 'right', size: 58, top: '28%' },
  { column: 1, opacity: 0.13, rotate: 12, side: 'right', size: 52, top: '38%' },
  { column: 0, opacity: 0.11, rotate: -20, side: 'right', size: 48, top: '46%' },
  { column: 1, opacity: 0.16, rotate: -12, side: 'right', size: 68, top: '56%' },
  { column: 0, opacity: 0.17, rotate: -14, side: 'right', size: 72, top: '64%' },
  { column: 1, opacity: 0.1, rotate: 20, side: 'right', size: 44, top: '74%' },
  { column: 0, opacity: 0.12, rotate: -24, side: 'right', size: 54, top: '84%' },
  { column: 1, opacity: 0.08, rotate: 26, side: 'right', size: 40, top: '90%' },
] as const;

const brandingColumnOffset = ['18px', '78px'] as const;

export const BackgroundBranding: React.FC = () => {
  return (
    <Stack sx={LayoutBackgroundStyles}>
      {brandingItems.map((item, index) => (
        <Box
          key={`${item.side}-${item.top}-${index}`}
          sx={{
            backgroundImage: 'url("/orange_logo.png")',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            height: `${item.size}px`,
            [item.side]: `max(${brandingColumnOffset[item.column]}, calc((100vw - 1600px) / 4 + ${brandingColumnOffset[item.column]}))`,
            opacity: item.opacity,
            position: 'absolute',
            top: item.top,
            transform: `translateY(-50%) rotate(${item.rotate}deg)`,
            width: `${item.size}px`,
          }}
        />
      ))}
    </Stack>
  );
};
